__turbopack_context__.v({
  "desktopMenu": "pMo8tW_desktopMenu",
  "headerButton": "pMo8tW_headerButton",
  "logInButton": "pMo8tW_logInButton",
  "mobMenuIcon": "pMo8tW_mobMenuIcon",
  "mobMenuOpen": "pMo8tW_mobMenuOpen",
  "open": "pMo8tW_open",
});
